export enum RelatorioVendedoresFiltro {
  VENDAS = 'VENDAS',
  CANCELAMENTOS = 'CANCELAMENTOS'
}
